module.exports = __webpack_public_path__ + "media/newstyle/images/icon-burger-white-ccc2bad688cfaed5eede363220c76613.svg";